/**
 * Created by Alican Köker
 * on 2018/02/13.
 */

import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {IReelStoppedData} from "@nolimitcity/slot-game/bin/core/reel/reel/ReelController";
import {ReelStopPresentationController} from "@nolimitcity/slot-game/bin/core/reelstoppresentation/ReelStopPresentationController";
import {SpinEvent} from "@nolimitcity/slot-game/bin/core/spin/event/SpinEvent";
import {WildNudgeParsedGameData} from "../server/data/WildNudgeParsedGameData";
import {BackgroundAnimationsView} from "./animations/backgroundAnimations/BackgroundAnimationsView";
import {GearAnimView} from "./animations/backgroundAnimations/GearAnimView";

export class BackgroundAnimationsController extends ReelStopPresentationController {

    public static readonly PLAY_STACKED_NO_WIN_ANIM:string = "playStackedNoWinAnim";
    public static readonly START_CONTINIOUS_ANIMATIONS:string = "startContiniousAnims";
    public static readonly STOP_CONTINIOUS_ANIMATIONS:string = "stopContiniousAnims";
    public static readonly SET_FLASH_LIGHTS:string = "setFlashLights";

    private _backgroundAnimationsView:BackgroundAnimationsView;
    private _gearAnimView:GearAnimView;
    private _animationStopReelId:number;

    constructor(index:number) {
        super(index, "BackgroundAnimationsController");
        this.init();
    }

    private init():void {
        this._gearAnimView = new GearAnimView();
        this._backgroundAnimationsView = new BackgroundAnimationsView();
    }

    protected addFeatureEventHandlers():void {
        EventHandler.addEventListener(this, SpinEvent.START, (event:GameEvent) => this.startSpinBGAnimations());
        EventHandler.addEventListener(this, BackgroundAnimationsController.START_CONTINIOUS_ANIMATIONS, (event:GameEvent) => this.startContiniousAnimations());
        EventHandler.addEventListener(this, BackgroundAnimationsController.STOP_CONTINIOUS_ANIMATIONS, (event:GameEvent) => this.stopContiniousAnimations());
        EventHandler.addEventListener(this, BackgroundAnimationsController.SET_FLASH_LIGHTS, (event:GameEvent) => this._backgroundAnimationsView.setRedFlashAnimations(event.params[0]));
        EventHandler.addEventListener(this, BackgroundAnimationsController.PLAY_STACKED_NO_WIN_ANIM, (event:GameEvent) => this._backgroundAnimationsView.playNoWinSteamAnimation(event.params[0]));
    }

    protected parseFeatureGameData(data:WildNudgeParsedGameData) {
        let lastAttentionId:number = data.nearWinReels.lastIndexOf(true);
        this._animationStopReelId = Math.max(2, lastAttentionId);
    }

    public onReelSpinStopped(data:IReelStoppedData):void {
        this.tryStopSpinBGAnimations(data);
        this.dispatchCompleteEvent(data.reelId);
    }

    private startSpinBGAnimations():void {
        this._gearAnimView.startGearAnimation();
        this._backgroundAnimationsView.startShaking();
        this._backgroundAnimationsView.startSpinSteamAnimations();
    }

    private tryStopSpinBGAnimations(data:IReelStoppedData):void {
        if(data.reelId === this._animationStopReelId) {
            this._backgroundAnimationsView.stopShaking();
            this._gearAnimView.endGearAnimation(data.quickStop || this._animationStopReelId > 2);
        }
    }

    private startContiniousAnimations():void {
        this._gearAnimView.startGearAnimation();
        this._backgroundAnimationsView.startShaking();
    }

    private stopContiniousAnimations():void {
        this._backgroundAnimationsView.stopShaking();
        this._backgroundAnimationsView.setRedFlashAnimations({val : false, fps : 30});
    }
}